export default __webpack_public_path__ + "static/media/junkrat-ult2.52bc219b.mp3";